/* -----------------Child components--------------- */
import { FilterView } from "@memorang/ui/src/components/FilterView";

import { useExamContext } from "@features/exam/contexts/ExamContext";
/* -----------------Others--------------- */
import useExams from "@hooks/useExams";
import { getPremiumContext } from "@memorang/helpers/src/bundle";
import type { BundleDetails } from "@memorang/types/src/bundle";
import { useToast } from "@memorang/ui/src/components/Toast";
import { useRouter } from "expo-router";
import { useMemo, useState } from "react";
import SearchNoResult from "../../../../assets/no-search-results.svg";

type Props = {
	handleClose?: () => void;
	searchIcon?: string;
	postExamContextSwitchCallback?: (newExamId: string) => void;
};

const getPurchasedProductsDescription = (
	purchasedProducts: BundleDetails[],
) => {
	return `Purchased: ${purchasedProducts
		.map((product) => {
			if (product.bundle.bundleType === "STUDY_PACK") {
				return "Study-Pack";
			}
			if (product.bundle.bundleType === "PRACTICE_TEST") {
				return "Practice Tests";
			}
			return product.bundle.name;
		})
		.join(", ")}`;
};
const ExamsFilterRouteView = ({
	handleClose,
	searchIcon,
	postExamContextSwitchCallback,
}: Props) => {
	const { groupedExams, examsList: exams } = useExams();

	const { showToast } = useToast();

	const {
		currentExamContext: { examId, examName },
		handleSwitchExamContext,
	} = useExamContext();

	const [selectedItemId, setSelectedItemId] = useState<string>(examId ?? "");

	const router = useRouter();

	const currentCategoryExamSelected = groupedExams?.find((item) => {
		return item.data.find(({ exam }) => exam.id === examId);
	});
	const sectionData = [...(groupedExams || [])]
		.sort(({ title }) => {
			return title === currentCategoryExamSelected?.title ? -1 : 1;
		})
		.map((group) => ({
			title: group.title,
			data: group.data.map(({ exam }) => {
				const purchasedProducts = exam.bundles.filter((bundle) => {
					return getPremiumContext(bundle.metadata).hasAccess;
				});
				return {
					name: exam.name,
					id: exam.id,
					description:
						purchasedProducts.length > 0
							? getPurchasedProductsDescription(purchasedProducts)
							: "",
				};
			}),
		}));

	const handleAction = async (selectedItemId: string, dismiss?: boolean) => {
		if (dismiss) {
			handleClose?.();
			return;
		}
		const examDetails = exams.find(({ exam }) => exam.id === selectedItemId);
		const message = `Switched Exam from "${examName}" to "${examDetails?.exam.name}"`;
		showToast({ message, duration: 500 });
		handleClose?.();
		router.replace("/home");
		await handleSwitchExamContext(examDetails!);
		postExamContextSwitchCallback?.(selectedItemId);
	};

	const selectedItem = useMemo(() => {
		return exams.find(({ exam }) => exam.id === selectedItemId);
	}, [exams, selectedItemId]);

	const cta = `Switch to ${selectedItem?.exam.name}`;
	return (
		<>
			<FilterView
				sectionData={sectionData}
				handleAction={handleAction}
				initSelectedItemId={selectedItemId}
				actionCta={cta}
				selectedItemId={selectedItemId}
				setSelectedItemId={setSelectedItemId}
				searchIcon={searchIcon}
				emptySearchResultSvg={SearchNoResult}
				currentItemSelectedLabel="Current Exam"
			/>
		</>
	);
};

export default ExamsFilterRouteView;
